import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { StripeIntent } from '../models/stripe/stripe-intent';
import { UserSubscription } from '../models/userSubscription';

@Injectable({
  providedIn: 'root'
})

export class StripeService {
    constructor(private http: HttpClient) {

    }

    public sendNotification(subId:string, amount:number, discount:number, vat:number):Observable<any>{
      // console.log(subId);
      return this.http.post(environment.apiEndpoint+'/api/stripe/sendNotification', {subId:subId, amount:amount, discount:discount, vat:vat}).pipe(
        map(
          res=>{
            // console.log(res);
            return res;
          }
        )
      );
    }

    public applyCoupon(couponCode:string):Observable<any>{
      return this.http.post(environment.apiEndpoint+`/api/stripe/applyCoupon`, {couponCode:couponCode}).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }

    public createIntent(amount: number, description: string = '', currency: string = 'gbp'): Observable<StripeIntent> {
        return this.http.post<StripeIntent>(environment.apiEndpoint + `/api/stripe/intent`, {amount:amount, description:description, currency:currency}).pipe(
            map(res => {
                return new StripeIntent(res);
            })
        );
    }

    public validateOrder(order_id): Observable<any>{
        return this.http.get<any>(environment.apiEndpoint + `/api/stripe/validate/${order_id}`).pipe(
            map(res => {
                return res;
            })
        );
    }

    public createCustomer(source): Observable<any> {
        return this.http.post<any>(environment.apiEndpoint + `/api/stripe/customer`, {source:source}).pipe(
            map(res => {
                return res;
            })
        );
    }

    public createSubscription(plan_id, quantity=1, billingCycleAnchor=false, country=''): Observable<any> {
        return this.http.post<any>(environment.apiEndpoint + `/api/stripe/subscription`, {plan:plan_id, quantity:quantity, billingCycleAnchor:billingCycleAnchor, country:country}).pipe(
            map(res => {
                return res;
            })
        );
    }

    public updateSubscription(sub_id, quantity):Observable<any>{
      return this.http.put(environment.apiEndpoint+'/api/stripe/subscription', {sub_id:sub_id, quantity:quantity}).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }

    public validateSubscription(sub_id): Observable<any> {
        return this.http.get<any>(environment.apiEndpoint + `/api/stripe/subscription/${sub_id}`).pipe(
            map(res => {
                return res;
            })
        );
    }

    public getCustomer():Observable<any>{
      return this.http.get(environment.apiEndpoint+`/api/stripe/customer`).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }
}

